module.exports = __webpack_public_path__ + "img/caneta.d73d4be7.svg";